import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://usvaxxafjnoqvwmxkygq.supabase.co'
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVzdmF4eGFmam5vcXZ3bXhreWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2NTk0MzIsImV4cCI6MjA3OTIzNTQzMn0._ghSkUXA34sFTW0bBS6wVgcL-TTweUvNDUrr0hP_Eew'
// Enhanced client configuration with cache-busting
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'X-Client-Info': 'ibd-rant-web',
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})
// Test function to check if we can reach Supabase directly
export const testDirectConnection = async () => {
  console.log(
    '🔍 Testing DIRECT connection to Supabase (bypassing everything)...',
  )
  try {
    const response = await fetch(
      `${supabaseUrl}/rest/v1/rants?select=id&limit=1`,
      {
        method: 'GET',
        headers: {
          apikey: supabaseAnonKey,
          Authorization: `Bearer ${supabaseAnonKey}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
      },
    )
    console.log('Direct fetch response:', {
      status: response.status,
      statusText: response.statusText,
      ok: response.ok,
    })
    if (response.ok) {
      const data = await response.json()
      console.log('✅ Direct connection successful!', data)
      return { success: true, data }
    } else {
      const text = await response.text()
      console.error('❌ Direct connection failed:', text)
      return { success: false, error: text }
    }
  } catch (error) {
    console.error('❌ Direct connection error:', error)
    return { success: false, error: (error as Error).message }
  }
}
